import * as angular from "angular";
import {isIgnoredTransitionError} from "./modules/commons/utils/transition-error.util";

angular
  .module('app')
  .config(AppConfig);

/* @ngInject */
function AppConfig($compileProvider, $mdDateLocaleProvider, $mdIconProvider, $locationProvider, $mdAriaProvider,
                   $provide) {

  $mdAriaProvider.disableWarnings();

  $locationProvider.html5Mode(true);
  $locationProvider.hashPrefix('');

  // ui-router 0.3 returns the transition promise from $state.go/transitionTo and nobody
  // chains onto it, so a superseded or aborted navigation leaves a rejected promise behind
  // and $q logs "Possibly unhandled rejection". The window 'unhandledrejection' listener in
  // app.run.ts cannot catch it because $q raises that warning itself rather than through a
  // native promise. Consume the rejection here; real failures are still routed by the
  // '$stateChangeError' handler in app.run.ts.
  $provide.decorator('$state', ['$delegate', '$log', function ($delegate, $log) {
    const transitionTo = $delegate.transitionTo;

    $delegate.transitionTo = function () {
      const transition = transitionTo.apply($delegate, arguments);

      if (transition && angular.isFunction(transition.catch)) {
        transition.catch(function (error) {
          if (!isIgnoredTransitionError(error)) {
            $log.debug('[Router] Transition failed', error);
          }
        });
      }

      return transition;
    };

    return $delegate;
  }]);

  // Make sure this still works in controllers (breaking change in angular 1.6)
  // $compileProvider.preAssignBindingsEnabled(true);

  // OLD (3/4/2019)
  // $mdDateLocaleProvider.formatDate = function(date) {
  //     return moment(date).format('DD-MM-YYYY');
  // };

  // Driver Requirments icons
  $mdIconProvider.icon('TutorialData', '/assets/images/requirementIcons/tutorial.svg');
  $mdIconProvider.icon('LicensePlateData', '/assets/images/requirementIcons/plate-number.svg');
  $mdIconProvider.icon('InsuranceData', '/assets/images/requirementIcons/insuence.svg');
  $mdIconProvider.icon('AgentLicenseData', '/assets/images/requirementIcons/driver-license.svg');
  $mdIconProvider.icon('AgentPhotoData', '/assets/images/requirementIcons/driver-photo.svg');
  $mdIconProvider.icon('InspectionData', '/assets/images/requirementIcons/tutorial.svg');
  $mdIconProvider.icon('VehicleRegistrationData', '/assets/images/requirementIcons/vehicle-registration.svg');
  $mdIconProvider.icon('DrivingHistoryReportData', '/assets/images/requirementIcons/MVR.svg');
  $mdIconProvider.icon('reg-stat-1', '/assets/images/icons/reg-stat-1.svg');
  $mdIconProvider.icon('reg-stat-2', '/assets/images/icons/reg-stat-2.svg');
  $mdIconProvider.icon('reg-stat-3', '/assets/images/icons/reg-stat-3.svg');
  $mdIconProvider.icon('reg-stat-4', '/assets/images/icons/reg-stat-4.svg');

  //Packages icons
  $mdIconProvider.icon('pack-envelope', '/assets/images/packTypes/envelope.svg');
  $mdIconProvider.icon('pack-box-small', '/assets/images/packTypes/small-pack.svg');
  $mdIconProvider.icon('pack-box-med', '/assets/images/packTypes/medium-pack.svg');
  $mdIconProvider.icon('pack-box-large', '/assets/images/packTypes/large-pack.svg');
  $mdIconProvider.icon('pack-special', '/assets/images/packTypes/roller.svg');
  $mdIconProvider.icon('pack-other', '/assets/images/packTypes/other.svg');
  $mdIconProvider.icon('pack-base', '/assets/images/packTypes/other.svg');
  $mdIconProvider.icon('pack-cool', '/assets/images/packTypes/cool.svg');
  $mdIconProvider.icon('pack-freeze', '/assets/images/packTypes/freeze.svg');
  $mdIconProvider.icon('pack-pallet', '/assets/images/packTypes/pallet-pack.svg');

  $mdIconProvider.icon('NoPackage', '/assets/images/packTypes/envelope.svg');
  $mdIconProvider.icon('SmallPackage', '/assets/images/packTypes/small-pack.svg');
  $mdIconProvider.icon('MediumPackage', '/assets/images/packTypes/medium-pack.svg');
  $mdIconProvider.icon('BigPackage', '/assets/images/packTypes/large-pack.svg');
  $mdIconProvider.icon('SpecialPackage', '/assets/images/packTypes/roller.svg');
  $mdIconProvider.icon('Other', '/assets/images/packTypes/other.svg');
  $mdIconProvider.icon('Extras', '/assets/images/packTypes/other.svg');
  $mdIconProvider.icon('CooledPackage', '/assets/images/packTypes/cool.svg');
  $mdIconProvider.icon('FrozenPackage', '/assets/images/packTypes/freeze.svg');
  $mdIconProvider.icon('Pallet', '/assets/images/packTypes/pallet-pack.svg');

  //Agent Type Icons for map
  $mdIconProvider.icon('driver', '/assets/images/icons/agents/driver_flat.svg');
  $mdIconProvider.icon('service-agent', '/assets/images/icons/agents/serviceagent_flat.svg');

  // All Sub-Task Action Icons
  $mdIconProvider.icon('TakePicture', '/assets/images/icons/v2/TakePicture.svg');
  $mdIconProvider.icon('PdfForm', '/assets/images/icons/v2/PdfForm.svg');
  $mdIconProvider.icon('Signature', '/assets/images/icons/v2/Signature.svg');
  $mdIconProvider.icon('visitSummary', '/assets/images/icons/v2/Signature.svg');
  $mdIconProvider.icon('DocumentScan', '/assets/images/icons/v2/DocumentScan.svg');
  $mdIconProvider.icon('FreeText', '/assets/images/icons/v2/DocumentScan.svg');
  $mdIconProvider.icon('BarcodeScan', '/assets/images/icons/v2/BarcodeScan.svg');
  $mdIconProvider.icon('BarcodePairing', '/assets/images/icons/v2/BarcodeScan.svg');


  $mdIconProvider.icon('FileUpload', '/assets/images/icons/v2/upload.svg');
  $mdIconProvider.icon('TakeVideo', '/assets/images/icons/v2/play.svg');

  // Supplier Icons
  $mdIconProvider.icon('Doordash', '/assets/images/icons/suppliers/Doordash.svg');
  $mdIconProvider.icon('Postmates', '/assets/images/icons/suppliers/Postmates.svg');
  $mdIconProvider.icon('Roadie', '/assets/images/icons/suppliers/Roadie.svg');
  $mdIconProvider.icon('UPS', '/assets/images/icons/suppliers/UPS.svg');
  $mdIconProvider.icon('USPS', '/assets/images/icons/suppliers/USPS.svg');
  $mdIconProvider.icon('Uber', '/assets/images/icons/suppliers/Uber.svg');

  // V2 Icons
  $mdIconProvider.icon('3pl-outline', '/assets/images/icons/v2/3pl-outline.svg');
  $mdIconProvider.icon('3pl', '/assets/images/icons/v2/3pl.svg');
  $mdIconProvider.icon('invite', '/assets/images/icons/v2/3pl.svg');
  $mdIconProvider.icon('account', '/assets/images/icons/v2/account.svg');
  $mdIconProvider.icon('add-package', '/assets/images/icons/v2/add-package.svg');
  $mdIconProvider.icon('agent', '/assets/images/icons/v2/agent.svg');
  $mdIconProvider.icon('agent-location', '/assets/images/icons/v2/agent-location.svg');
  $mdIconProvider.icon('agent-tracking', '/assets/images/icons/v2/agent-tracking.svg');
  $mdIconProvider.icon('allocation', '/assets/images/icons/v2/allocation.svg');
  $mdIconProvider.icon('arrow-connection', '/assets/images/icons/v2/arrow-connection.svg');
  $mdIconProvider.icon('arrow-down', '/assets/images/icons/v2/arrow-down.svg');
  $mdIconProvider.icon('arrow-left', '/assets/images/icons/v2/arrow-left.svg');
  $mdIconProvider.icon('arrow-left-circle', '/assets/images/icons/v2/arrow-left-circle.svg');
  $mdIconProvider.icon('arrow-right', '/assets/images/icons/v2/arrow-right.svg');
  $mdIconProvider.icon('arrow-right-circle', '/assets/images/icons/v2/arrow-right-circle.svg');
  $mdIconProvider.icon('arrow-up', '/assets/images/icons/v2/arrow-up.svg');
  $mdIconProvider.icon('assign', '/assets/images/icons/v2/assign.svg');
  $mdIconProvider.icon('play', '/assets/images/icons/v2/play.svg');
  $mdIconProvider.icon('hold', '/assets/images/icons/v2/hold.svg');
  $mdIconProvider.icon('assign-outline', '/assets/images/icons/v2/assign-outline.svg');
  $mdIconProvider.icon('assistant', '/assets/images/icons/v2/assistant.svg');
  $mdIconProvider.icon('attachment', '/assets/images/icons/v2/attachment.svg');
  $mdIconProvider.icon('autonomous-vehicle', '/assets/images/icons/v2/autonomous-vehicle.svg');
  $mdIconProvider.icon('billing', '/assets/images/icons/v2/billing.svg');
  $mdIconProvider.icon('barcode', '/assets/images/icons/v2/barcode.svg');
  $mdIconProvider.icon('battery-high', '/assets/images/icons/v2/battery-high.svg');
  $mdIconProvider.icon('battery-low', '/assets/images/icons/v2/battery-low.svg');
  $mdIconProvider.icon('battery-med', '/assets/images/icons/v2/battery-med.svg');
  $mdIconProvider.icon('bicycle', '/assets/images/icons/v2/bicycle.svg');
  $mdIconProvider.icon('branch', '/assets/images/icons/v2/branch.svg');
  $mdIconProvider.icon('bringoz', '/assets/images/icons/v2/bringoz.svg');
  $mdIconProvider.icon('calendar', '/assets/images/icons/v2/calendar.svg');
  $mdIconProvider.icon('calendar-outline', '/assets/images/icons/v2/calendar-outline.svg');
  $mdIconProvider.icon('calendar-plus', '/assets/images/icons/v2/calendar-plus.svg');
  $mdIconProvider.icon('calendar-star', '/assets/images/icons/v2/calendar-star.svg');
  $mdIconProvider.icon('cannabis', '/assets/images/icons/v2/cannabis.svg');
  $mdIconProvider.icon('carousel', '/assets/images/icons/v2/carousel.svg');
  $mdIconProvider.icon('carrier', '/assets/images/icons/v2/carrier.svg');
  $mdIconProvider.icon('cash', '/assets/images/icons/v2/cash.svg');
  $mdIconProvider.icon('chat', '/assets/images/icons/v2/chat.svg');
  $mdIconProvider.icon('carriers', '/assets/images/icons/v2/carriers.svg');
  $mdIconProvider.icon('check-circle', '/assets/images/icons/v2/check-circle.svg');
  $mdIconProvider.icon('check-partial', '/assets/images/icons/v2/check-partial.svg');
  $mdIconProvider.icon('check-circle-outline', '/assets/images/icons/v2/check-circle-outline.svg');
  $mdIconProvider.icon('chevron-down', '/assets/images/icons/v2/chevron-down.svg');
  $mdIconProvider.icon('chevron-left', '/assets/images/icons/v2/chevron-left.svg');
  $mdIconProvider.icon('chevron-right', '/assets/images/icons/v2/chevron-right.svg');
  $mdIconProvider.icon('status', '/assets/images/icons/v2/status.svg');
  $mdIconProvider.icon('chevron-up', '/assets/images/icons/v2/chevron-up.svg');
  $mdIconProvider.icon('clocked-out', '/assets/images/icons/v2/clocked-out.svg');
  $mdIconProvider.icon('clocked-in', '/assets/images/icons/v2/clocked-in.svg');
  $mdIconProvider.icon('close', '/assets/images/icons/v2/close.svg');
  $mdIconProvider.icon('close-circle', '/assets/images/icons/v2/close-circle.svg');
  $mdIconProvider.icon('close-circle-outline', '/assets/images/icons/v2/close-circle-outline.svg');
  $mdIconProvider.icon('close-circle-white-bg', '/assets/images/icons/v2/close-circle-white-bg.svg');
  $mdIconProvider.icon('cluster', '/assets/images/icons/v2/cluster.svg');
  $mdIconProvider.icon('collect', '/assets/images/icons/v2/collect.svg');
  $mdIconProvider.icon('Collect', '/assets/images/icons/v2/collect.svg');
  $mdIconProvider.icon('color-fill', '/assets/images/icons/v2/color-fill.svg');
  $mdIconProvider.icon('company', '/assets/images/icons/v2/company.svg');
  $mdIconProvider.icon('compare', '/assets/images/icons/v2/compare.svg');
  $mdIconProvider.icon('contact-circle', '/assets/images/icons/v2/contact-circle.svg');
  $mdIconProvider.icon('cooling', '/assets/images/icons/v2/cooling.svg');
  $mdIconProvider.icon('contract', '/assets/images/icons/v2/contract.svg');
  $mdIconProvider.icon('customer', '/assets/images/icons/v2/customer.svg');
  $mdIconProvider.icon('credit-card', '/assets/images/icons/v2/credit-card.svg');
  $mdIconProvider.icon('customer-outline', '/assets/images/icons/v2/customer-outline.svg');
  $mdIconProvider.icon('date-time', '/assets/images/icons/v2/date-time.svg');
  $mdIconProvider.icon('reactivate', '/assets/images/icons/v2/reactivate.svg');
  $mdIconProvider.icon('record', '/assets/images/icons/v2/record.svg');
  $mdIconProvider.icon('deactivate', '/assets/images/icons/v2/deactivate.svg');
  $mdIconProvider.icon('default', '/assets/images/icons/v2/default.svg');
  $mdIconProvider.icon('depot', '/assets/images/icons/v2/depot.svg');
  $mdIconProvider.icon('dispatch', '/assets/images/icons/v2/dispatch.svg');
  $mdIconProvider.icon('distance', '/assets/images/icons/v2/distance.svg');
  $mdIconProvider.icon('dollar', '/assets/images/icons/v2/dollar.svg');
  $mdIconProvider.icon('dollar-circle', '/assets/images/icons/v2/dollar-circle.svg');
  $mdIconProvider.icon('download', '/assets/images/icons/v2/download.svg');
  $mdIconProvider.icon('drag', '/assets/images/icons/v2/drag.svg');
  $mdIconProvider.icon('duplicate', '/assets/images/icons/v2/duplicate.svg');
  $mdIconProvider.icon('duplicate-outline', '/assets/images/icons/v2/duplicate-outline.svg');
  $mdIconProvider.icon('edit', '/assets/images/icons/v2/edit.svg');
  $mdIconProvider.icon('edit-outline', '/assets/images/icons/v2/edit-outline.svg');
  $mdIconProvider.icon('electriccar', '/assets/images/icons/v2/electriccar.svg');
  $mdIconProvider.icon('electricvehicle', '/assets/images/icons/v2/ELECTRIC.svg');
  $mdIconProvider.icon('electrictruck', '/assets/images/icons/v2/electrictruck.svg');
  $mdIconProvider.icon('electricvan', '/assets/images/icons/v2/electricvan.svg');
  $mdIconProvider.icon('elevator', '/assets/images/icons/v2/elevator.svg');
  $mdIconProvider.icon('email', '/assets/images/icons/v2/email.svg');
  $mdIconProvider.icon('flag-end', '/assets/images/icons/v2/flag-end.svg');
  $mdIconProvider.icon('flag-start', '/assets/images/icons/v2/flag-start.svg');
  $mdIconProvider.icon('forklift', '/assets/images/icons/v2/forklift.svg');
  $mdIconProvider.icon('error', '/assets/images/icons/v2/error.svg');
  $mdIconProvider.icon('error-outline', '/assets/images/icons/v2/error-outline.svg');
  $mdIconProvider.icon('eta', '/assets/images/icons/v2/eta.svg');
  $mdIconProvider.icon('etd', '/assets/images/icons/v2/etd.svg');
  $mdIconProvider.icon('expand', '/assets/images/icons/v2/expand.svg');
  $mdIconProvider.icon('collapse', '/assets/images/icons/v2/collapse.svg');
  $mdIconProvider.icon('extension', '/assets/images/icons/v2/extension.svg');
  $mdIconProvider.icon('eye-off', '/assets/images/icons/v2/eye-off.svg');
  $mdIconProvider.icon('eye-on', '/assets/images/icons/v2/eye-on.svg');
  $mdIconProvider.icon('file', '/assets/images/icons/v2/file.svg');
  $mdIconProvider.icon('filter', '/assets/images/icons/v2/filter.svg');
  $mdIconProvider.icon('filters-list', '/assets/images/icons/v2/filters-list.svg');
  $mdIconProvider.icon('fit', '/assets/images/icons/v2/fit.svg');
  $mdIconProvider.icon('freeze', '/assets/images/icons/v2/freeze.svg');
  $mdIconProvider.icon('fulfillment', '/assets/images/icons/v2/fulfillment.svg');
  $mdIconProvider.icon('fit-to-screen', '/assets/images/icons/v2/fit-to-screen.svg');
  $mdIconProvider.icon('gantt', '/assets/images/icons/v2/gantt.svg');
  $mdIconProvider.icon('geo-time', '/assets/images/icons/v2/geo-time.svg');
  $mdIconProvider.icon('gps', '/assets/images/icons/v2/gps.svg');
  $mdIconProvider.icon('hash', '/assets/images/icons/v2/hash.svg');
  $mdIconProvider.icon('help', '/assets/images/icons/v2/help.svg');
  $mdIconProvider.icon('help-outline', '/assets/images/icons/v2/help-outline.svg');
  $mdIconProvider.icon('hide', '/assets/images/icons/v2/hide.svg');
  $mdIconProvider.icon('home', '/assets/images/icons/v2/home.svg');
  $mdIconProvider.icon('id-card', '/assets/images/icons/v2/id-card.svg');
  $mdIconProvider.icon('idle-time', '/assets/images/icons/v2/idle-time.svg');
  $mdIconProvider.icon('import', '/assets/images/icons/v2/import.svg');
  $mdIconProvider.icon('info', '/assets/images/icons/v2/info.svg');
  $mdIconProvider.icon('info-outline', '/assets/images/icons/v2/info-outline.svg');
  $mdIconProvider.icon('label', '/assets/images/icons/v2/label.svg');
  $mdIconProvider.icon('label-outline', '/assets/images/icons/v2/label-outline.svg');
  $mdIconProvider.icon('layers', '/assets/images/icons/v2/layers.svg');
  $mdIconProvider.icon('layers-plus', '/assets/images/icons/v2/layers-plus.svg');
  $mdIconProvider.icon('leftover', '/assets/images/icons/v2/leftover.svg');
  $mdIconProvider.icon('linked', '/assets/images/icons/v2/linked.svg');
  $mdIconProvider.icon('list-check', '/assets/images/icons/v2/list-check.svg');
  $mdIconProvider.icon('location-pin', '/assets/images/icons/v2/location-pin.svg');
  $mdIconProvider.icon('location', '/assets/images/icons/v2/location-pin.svg');
  $mdIconProvider.icon('map-marker', '/assets/images/icons/v2/location-pin.svg');
  $mdIconProvider.icon('location-pin-check', '/assets/images/icons/v2/location-pin-check.svg');
  $mdIconProvider.icon('location-pin-check-outline', '/assets/images/icons/v2/location-pin-check-outline.svg');
  $mdIconProvider.icon('location-pin-check-outline-no', '/assets/images/icons/v2/location-pin-check-outline-no.svg');
  $mdIconProvider.icon('location-pin-edit', '/assets/images/icons/v2/location-pin-edit.svg');
  $mdIconProvider.icon('location-pin-outline', '/assets/images/icons/v2/location-pin-outline.svg');
  $mdIconProvider.icon('location-pin-plus', '/assets/images/icons/v2/location-pin-plus.svg');
  $mdIconProvider.icon('location-pin-plus-outline', '/assets/images/icons/v2/location-pin-plus-outline.svg');
  $mdIconProvider.icon('location-pin-service-outline', '/assets/images/icons/v2/location-pin-service-outline.svg');
  $mdIconProvider.icon('location-pin-check-outline-no', '/assets/images/icons/v2/location-pin-check-outline-no.svg');
  $mdIconProvider.icon('lock', '/assets/images/icons/v2/lock.svg');
  $mdIconProvider.icon('lock-down', '/assets/images/icons/v2/lock-down.svg');
  $mdIconProvider.icon('lock-open-outline', '/assets/images/icons/v2/lock-open-outline.svg');
  $mdIconProvider.icon('lock-outline', '/assets/images/icons/v2/lock-outline.svg');
  $mdIconProvider.icon('lock-up', '/assets/images/icons/v2/lock-up.svg');
  $mdIconProvider.icon('mandatory-pod', '/assets/images/icons/v2/mandatory-pod.svg');
  $mdIconProvider.icon('map', '/assets/images/icons/v2/map.svg');
  $mdIconProvider.icon('map-outline', '/assets/images/icons/v2/map-outline.svg');
  $mdIconProvider.icon('market', '/assets/images/icons/v2/market.svg');
  $mdIconProvider.icon('market-outline', '/assets/images/icons/v2/market-outline.svg');
  $mdIconProvider.icon('menu', '/assets/images/icons/v2/menu.svg');
  $mdIconProvider.icon('menu-vertical', '/assets/images/icons/v2/menu-vertical.svg');
  $mdIconProvider.icon('message', '/assets/images/icons/v2/message.svg');
  $mdIconProvider.icon('message-outline', '/assets/images/icons/v2/message-outline.svg');
  $mdIconProvider.icon('minimize', '/assets/images/icons/v2/minimize.svg');
  $mdIconProvider.icon('maximize', '/assets/images/icons/v2/maximize.svg');
  $mdIconProvider.icon('minus', '/assets/images/icons/v2/minus.svg');
  $mdIconProvider.icon('minus-circle', '/assets/images/icons/v2/minus-circle.svg');
  $mdIconProvider.icon('mobile', '/assets/images/icons/v2/mobile.svg');
  $mdIconProvider.icon('motorcycle', '/assets/images/icons/v2/motorcycle.svg');
  $mdIconProvider.icon('note', '/assets/images/icons/v2/note.svg');
  $mdIconProvider.icon('notpacked', '/assets/images/icons/v2/notpacked.svg');
  $mdIconProvider.icon('obligate', '/assets/images/icons/v2/obligate.svg');
  $mdIconProvider.icon('onDuty', '/assets/images/icons/v2/on-duty.svg');
  $mdIconProvider.icon('offDuty', '/assets/images/icons/v2/off-duty.svg');
  $mdIconProvider.icon('open', '/assets/images/icons/v2/open.svg');
  $mdIconProvider.icon('orders', '/assets/images/icons/v2/orders.svg');
  $mdIconProvider.icon('orders-settings', '/assets/images/icons/v2/orders-settings.svg');
  $mdIconProvider.icon('orders-upload', '/assets/images/icons/v2/orders-upload.svg');
  $mdIconProvider.icon('package', '/assets/images/icons/v2/package.svg');
  $mdIconProvider.icon('package-check', '/assets/images/icons/v2/package-check.svg');
  $mdIconProvider.icon('package-outline', '/assets/images/icons/v2/package-outline.svg');
  $mdIconProvider.icon('package-time', '/assets/images/icons/v2/package-time.svg');
  $mdIconProvider.icon('pallets', '/assets/images/icons/v2/pallets.svg');
  $mdIconProvider.icon('panels', '/assets/images/icons/v2/panels.svg');
  $mdIconProvider.icon('pay', '/assets/images/icons/v2/pay.svg');
  $mdIconProvider.icon('Payment', '/assets/images/icons/v2/Payment.svg');
  $mdIconProvider.icon('pdf', '/assets/images/icons/v2/pdf.svg');
  $mdIconProvider.icon('phone', '/assets/images/icons/v2/phone.svg');
  $mdIconProvider.icon('phone-outline', '/assets/images/icons/v2/phone-outline.svg');
  $mdIconProvider.icon('pie-chart', '/assets/images/icons/v2/pie-chart.svg');
  $mdIconProvider.icon('pin', '/assets/images/icons/v2/pin.svg');
  $mdIconProvider.icon('planning', '/assets/images/icons/v2/planning.svg');
  $mdIconProvider.icon('planning-logs', '/assets/images/icons/v2/planning-logs.svg');
  $mdIconProvider.icon('planning-settings', '/assets/images/icons/v2/planning-settings.svg');
  $mdIconProvider.icon('play-outline', '/assets/images/icons/v2/play-outline.svg');
  $mdIconProvider.icon('plus-circle', '/assets/images/icons/v2/plus-circle.svg');
  $mdIconProvider.icon('point-of-sale', '/assets/images/icons/v2/point-of-sale.svg');
  $mdIconProvider.icon('point-to-point', '/assets/images/icons/v2/point-to-point.svg');
  $mdIconProvider.icon('print', '/assets/images/icons/v2/print.svg');
  $mdIconProvider.icon('priority', '/assets/images/icons/v2/priority.svg');

  $mdIconProvider.icon('copy', '/assets/images/icons/v2/copy.svg');
  $mdIconProvider.icon('print-outline', '/assets/images/icons/v2/print-outline.svg');
  $mdIconProvider.icon('privatecar', '/assets/images/icons/v2/privatecar.svg');
  $mdIconProvider.icon('car', '/assets/images/icons/v2/privatecar.svg');
  $mdIconProvider.icon('scooter', '/assets/images/icons/v2/scooter.svg');
  $mdIconProvider.icon('vehicles', '/assets/images/icons/v2/vehicles.svg');
  $mdIconProvider.icon('vehicles@2x', '/assets/images/icons/v2/vehicles@2x.svg');
  $mdIconProvider.icon('program', '/assets/images/icons/v2/program.svg');
  $mdIconProvider.icon('projects', '/assets/images/icons/v2/projects.svg');
  $mdIconProvider.icon('recurring', '/assets/images/icons/v2/recurring.svg');
  $mdIconProvider.icon('reoptimize', '/assets/images/icons/v2/reoptimize.svg');
  $mdIconProvider.icon('report', '/assets/images/icons/v2/report.svg');
  $mdIconProvider.icon('reset', '/assets/images/icons/v2/reset.svg');
  $mdIconProvider.icon('refresh', '/assets/images/icons/v2/refresh.svg');
  $mdIconProvider.icon('route', '/assets/images/icons/v2/route.svg');
  $mdIconProvider.icon('save', '/assets/images/icons/v2/save.svg');
  $mdIconProvider.icon('schedule-call', '/assets/images/icons/v2/schedule-call.svg');
  $mdIconProvider.icon('scheduled-call', '/assets/images/icons/v2/scheduled-call.svg');
  $mdIconProvider.icon('search', '/assets/images/icons/v2/search.svg');
  $mdIconProvider.icon('search-outline', '/assets/images/icons/v2/search-outline.svg');
  $mdIconProvider.icon('self-pickup', '/assets/images/icons/v2/self-pickup.svg');
  $mdIconProvider.icon('service-area', '/assets/images/icons/v2/service-area.svg');
  $mdIconProvider.icon('settings', '/assets/images/icons/v2/settings.svg');
  $mdIconProvider.icon('settings-outline', '/assets/images/icons/v2/settings-outline.svg');
  $mdIconProvider.icon('shipper', '/assets/images/icons/v2/shipper.svg');
  $mdIconProvider.icon('show', '/assets/images/icons/v2/show.svg');
  $mdIconProvider.icon('skill', '/assets/images/icons/v2/skill.svg');
  $mdIconProvider.icon('sku', '/assets/images/icons/v2/sku.svg');
  $mdIconProvider.icon('sort', '/assets/images/icons/v2/sort.svg');
  $mdIconProvider.icon('sort-asc', '/assets/images/icons/v2/sort-asc.svg');
  $mdIconProvider.icon('sort-desc', '/assets/images/icons/v2/sort-desc.svg');
  $mdIconProvider.icon('sort-list', '/assets/images/icons/v2/sort-list.svg');
  $mdIconProvider.icon('support', '/assets/images/icons/v2/support.svg');
  $mdIconProvider.icon('support-outline', '/assets/images/icons/v2/support-outline.svg');
  $mdIconProvider.icon('survey', '/assets/images/icons/v2/survey.svg');
  $mdIconProvider.icon('sla', '/assets/images/icons/v2/sla.svg');
  $mdIconProvider.icon('swap', '/assets/images/icons/v2/swap.svg');
  $mdIconProvider.icon('table', '/assets/images/icons/v2/table.svg');
  $mdIconProvider.icon('tag', '/assets/images/icons/v2/tag.svg');
  $mdIconProvider.icon('tag-outline', '/assets/images/icons/v2/tag-outline.svg');
  $mdIconProvider.icon('task', '/assets/images/icons/v2/task.svg');
  $mdIconProvider.icon('template', '/assets/images/icons/v2/template.svg');
  $mdIconProvider.icon('text-area', '/assets/images/icons/v2/text-area.svg');
  $mdIconProvider.icon('tiles', '/assets/images/icons/v2/tiles.svg');
  $mdIconProvider.icon('tiles-outline', '/assets/images/icons/v2/tiles-outline.svg');
  $mdIconProvider.icon('time-off', '/assets/images/icons/v2/time-off.svg');
  $mdIconProvider.icon('timeline', '/assets/images/icons/v2/timeline.svg');
  $mdIconProvider.icon('time-window', '/assets/images/icons/v2/time-window.svg');
  $mdIconProvider.icon('time-window-outline', '/assets/images/icons/v2/time-window-outline.svg');
  $mdIconProvider.icon('time-zone', '/assets/images/icons/v2/time-zone.svg');
  $mdIconProvider.icon('timer', '/assets/images/icons/v2/timer.svg');
  $mdIconProvider.icon('timer-outline', '/assets/images/icons/v2/timer-outline.svg');
  $mdIconProvider.icon('tractor', '/assets/images/icons/v2/tractor.svg');
  $mdIconProvider.icon('trailer', '/assets/images/icons/v2/trailer.svg');
  $mdIconProvider.icon('trash', '/assets/images/icons/v2/trash.svg');
  $mdIconProvider.icon('truck', '/assets/images/icons/v2/truck.svg');
  $mdIconProvider.icon('truck-outline', '/assets/images/icons/v2/truck-outline.svg');
  $mdIconProvider.icon('unbind', '/assets/images/icons/v2/unbind.svg');
  $mdIconProvider.icon('uncheck-circle', '/assets/images/icons/v2/uncheck-circle.svg');
  $mdIconProvider.icon('ungroup', '/assets/images/icons/v2/ungroup.svg');
  $mdIconProvider.icon('upload', '/assets/images/icons/v2/upload.svg');
  $mdIconProvider.icon('valid', '/assets/images/icons/v2/valid.svg');
  $mdIconProvider.icon('van', '/assets/images/icons/v2/van.svg');
  $mdIconProvider.icon('volume', '/assets/images/icons/v2/volume.svg');
  $mdIconProvider.icon('weight', '/assets/images/icons/v2/weight.svg');
  $mdIconProvider.icon('sms', '/assets/images/icons/v2/sms.svg');
  $mdIconProvider.icon('drag', '/assets/images/icons/v2/drag.svg');
  $mdIconProvider.icon('voucher', '/assets/images/icons/v2/voucher.svg');
  $mdIconProvider.icon('archive', '/assets/images/icons/v2/archive.svg');
  $mdIconProvider.icon('dashboard', '/assets/images/icons/v2/dashboard.svg');
  $mdIconProvider.icon('team', '/assets/images/icons/v2/team.svg');

  $mdIconProvider.icon('book', '/assets/images/icons/v2/book.svg');
  $mdIconProvider.icon('brush', '/assets/images/icons/v2/brush.svg');
  $mdIconProvider.icon('log-in', '/assets/images/icons/v2/log-in.svg');
  $mdIconProvider.icon('mouse', '/assets/images/icons/v2/mouse.svg');
  $mdIconProvider.icon('no-wifi', '/assets/images/icons/v2/no-wifi.svg');
  $mdIconProvider.icon('notifications', '/assets/images/icons/v2/notifications.svg');
  $mdIconProvider.icon('remote-control', '/assets/images/icons/v2/remote-control.svg');
  $mdIconProvider.icon('windows', '/assets/images/icons/v2/windows.svg');

  $mdIconProvider.icon('function', '/assets/images/icons/v2/function.svg');
  $mdIconProvider.icon('google', '/assets/images/icons/v2/google.svg');
  $mdIconProvider.icon('group', '/assets/images/icons/v2/group.svg');
  $mdIconProvider.icon('account-group', '/assets/images/icons/v2/group.svg');
  $mdIconProvider.icon('merge', '/assets/images/icons/v2/merge.svg');
  $mdIconProvider.icon('mobile-menu', '/assets/images/icons/v2/mobile-menu.svg');
  $mdIconProvider.icon('redo', '/assets/images/icons/v2/redo.svg');
  $mdIconProvider.icon('rotate', '/assets/images/icons/v2/rotate.svg');
  $mdIconProvider.icon('skill-outline', '/assets/images/icons/v2/skill-outline.svg');
  $mdIconProvider.icon('turning', '/assets/images/icons/v2/turning.svg');
  $mdIconProvider.icon('user-add', '/assets/images/icons/v2/user-add.svg');
  $mdIconProvider.icon('windows', '/assets/images/icons/v2/windows.svg');

  $mdIconProvider.icon('cube', '/assets/images/icons/v2/cube.svg');
  $mdIconProvider.icon('signs', '/assets/images/icons/v2/signs.svg');
  $mdIconProvider.icon('sitemap', '/assets/images/icons/v2/sitemap.svg');
  $mdIconProvider.icon('street-view', '/assets/images/icons/v2/street-view.svg');
  $mdIconProvider.icon('reaction', '/assets/images/icons/v2/reaction.svg');
  $mdIconProvider.icon('check', '/assets/images/icons/v2/check.svg');
  $mdIconProvider.icon('default-agent', '/assets/images/icons/v2/default-agent.svg');
  $mdIconProvider.icon('resource', '/assets/images/icons/v2/resource.svg');
  $mdIconProvider.icon('resources', '/assets/images/icons/v2/resources.svg');
  $mdIconProvider.icon('link-to', '/assets/images/icons/v2/link-to.svg');
  $mdIconProvider.icon('plus', '/assets/images/icons/v2/plus.svg');
  $mdIconProvider.icon('plus-circle', '/assets/images/icons/v2/plus-circle.svg');
  $mdIconProvider.icon('settings-slider', '/assets/images/icons/v2/settings-slider.svg');
  $mdIconProvider.icon('export', '/assets/images/icons/v2/export.svg');
  $mdIconProvider.icon('export-xsl', '/assets/images/icons/v2/export-xsl.svg');
  $mdIconProvider.icon('relation', '/assets/images/icons/v2/relation.svg');
  $mdIconProvider.icon('webhook', '/assets/images/icons/v2/webhook.svg');
  $mdIconProvider.icon('wifi', '/assets/images/icons/v2/wifi.svg');
  $mdIconProvider.icon('speed', '/assets/images/icons/v2/speed.svg');
  $mdIconProvider.icon('split', '/assets/images/icons/v2/split.svg');
  $mdIconProvider.icon('spot', '/assets/images/icons/v2/spot.svg');
  $mdIconProvider.icon('start-day', '/assets/images/icons/v2/start-day.svg');
  $mdIconProvider.icon('first-mile', '/assets/images/icons/v2/first-mile.svg');
  $mdIconProvider.icon('middle-mile', '/assets/images/icons/v2/middle-mile.svg');
  $mdIconProvider.icon('last-mile', '/assets/images/icons/v2/last-mile.svg');
  $mdIconProvider.icon('business', '/assets/images/icons/v2/business.svg');
  $mdIconProvider.icon('return', '/assets/images/icons/v2/return.svg');

  $mdIconProvider.icon('location-live', '/assets/images/icons/v2/location-live.svg');
  $mdIconProvider.icon('location-required', '/assets/images/icons/v2/location-required.svg');
  $mdIconProvider.icon('user-outline', '/assets/images/icons/v2/user-outline.svg');
  $mdIconProvider.icon('pod', '/assets/images/icons/v2/pod.svg');
  $mdIconProvider.icon('blocked-phone', '/assets/images/icons/v2/blocked-phone.svg');
  $mdIconProvider.icon('meta-data', '/assets/images/icons/v2/meta-data.svg');
  $mdIconProvider.icon('move-package', '/assets/images/icons/v2/move-package.svg');
  $mdIconProvider.icon('quick-filters', '/assets/images/icons/v2/quick-filters.svg');
  $mdIconProvider.icon('commission-delta', '/assets/images/icons/v2/commission-delta.svg');
  $mdIconProvider.icon('hand-outline', '/assets/images/icons/v2/hand-outline.svg');
  $mdIconProvider.icon('hand-draw', '/assets/images/icons/v2/hand-draw.svg');

  // SERVER ICONS - Package Items
  $mdIconProvider.icon('BAG', '/assets/images/icons/v2/BAG.svg');
  $mdIconProvider.icon('BIG_CONTAINER', '/assets/images/icons/v2/BIG_CONTAINER.svg');
  $mdIconProvider.icon('BOX', '/assets/images/icons/v2/BOX.svg');
  $mdIconProvider.icon('BOXES', '/assets/images/icons/v2/BOXES.svg');
  $mdIconProvider.icon('CANNABIS', '/assets/images/icons/v2/CANNABIS.svg');
  $mdIconProvider.icon('CAR', '/assets/images/icons/v2/CAR.svg');
  $mdIconProvider.icon('CART', '/assets/images/icons/v2/CART.svg');
  $mdIconProvider.icon('CONTAINERS', '/assets/images/icons/v2/CONTAINERS.svg');
  $mdIconProvider.icon('COOLING_ITEM', '/assets/images/icons/v2/COOLING_ITEM.svg');
  $mdIconProvider.icon('ELECTRIC', '/assets/images/icons/v2/ELECTRIC.svg');
  $mdIconProvider.icon('FLAT_BOX', '/assets/images/icons/v2/FLAT_BOX.svg');
  $mdIconProvider.icon('FRAGILE_ITEM', '/assets/images/icons/v2/FRAGILE_ITEM.svg');
  $mdIconProvider.icon('FREEZE_ITEM', '/assets/images/icons/v2/FREEZE_ITEM.svg');
  $mdIconProvider.icon('LARGE_BOX', '/assets/images/icons/v2/LARGE_BOX.svg');
  $mdIconProvider.icon('LONG_BOX', '/assets/images/icons/v2/LONG_BOX.svg');
  $mdIconProvider.icon('MATERIAL', '/assets/images/icons/v2/MATERIAL.svg');
  $mdIconProvider.icon('MEDICAL', '/assets/images/icons/v2/MEDICAL.svg');
  $mdIconProvider.icon('MEDIUM_BOX', '/assets/images/icons/v2/MEDIUM_BOX.svg');
  $mdIconProvider.icon('PALLET', '/assets/images/icons/v2/PALLET.svg');
  $mdIconProvider.icon('RADIOACTIVE', '/assets/images/icons/v2/RADIOACTIVE.svg');
  $mdIconProvider.icon('SAFE', '/assets/images/icons/v2/SAFE.svg');
  $mdIconProvider.icon('SMALL_BOX', '/assets/images/icons/v2/SMALL_BOX.svg');
  $mdIconProvider.icon('SMALL_CONTAINER', '/assets/images/icons/v2/SMALL_CONTAINER.svg');
  $mdIconProvider.icon('SUITCASE', '/assets/images/icons/v2/SUITCASE.svg');
  $mdIconProvider.icon('WARM_ITEM', '/assets/images/icons/v2/WARM_ITEM.svg');
  $mdIconProvider.icon('route-split', '/assets/images/icons/v2/route-split.svg');
  $mdIconProvider.icon('star-blue-outline', '/assets/images/icons/v2/star-blue-outline.svg');
  $mdIconProvider.icon('star-blue-closed', '/assets/images/icons/v2/star-blue-closed.svg');
  $mdIconProvider.icon('no-app', '/assets/images/icons/v2/no-app.svg');
}
